import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

import {SkeletonItem} from '@edna/components/primitives';

import {Text} from 'src/components/primitives';

import {TAvailableTariff} from '../../definitions';
import * as S from './style';
import {useLicensePrices} from './usePrices';

type TLicensePricingProps = {
  tariff: TAvailableTariff;
};

const LicensePricing = React.memo<TLicensePricingProps>(({tariff}) => {
  const {t} = useTranslation();

  const licensePrices = useLicensePrices(tariff);

  if (!licensePrices || !tariff) {
    return (
      <S.LoadingContainer>
        <SkeletonItem height="50px" />
        <SkeletonItem height="50px" />
      </S.LoadingContainer>
    );
  }

  return (
    <S.Pricing>
      <Text weight={500}>
        {t('Tariffs:licensePricing.licensePrice')}
        <Text secondary size="S" topIndent="1">
          {t('Tariffs:licensePricing.licensePriceHint', {
            currency: licensePrices.currency,
            licensePrice: licensePrices.licensePrice,
          })}
        </Text>
      </Text>
      <Text secondary size="XS">
        <Trans i18nKey="Tariffs:licensePricing.pricingHint" />
      </Text>
    </S.Pricing>
  );
});

LicensePricing.displayName = 'LicensePricing';

export {LicensePricing};
